import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import Breadcrumbs from "../components/Breadcrumbs";
import ServiceAreaMap from "../components/ServiceAreaMap";
import CTASection from "../components/CTASection";
import { SERVICE_AREAS } from "../data/site";

export default function ServiceAreas() {
  return (
    <>
      <SEO
        title="Service Areas"
        description="Yavapai Waste Solutions delivers roll-off dumpsters and front-load service across Prescott, Prescott Valley, Chino Valley, Paulden, Williamson Valley, Dewey, Humboldt & Cordes Junction."
        path="/service-areas"
      />
      <section className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-14">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Service Areas" }]} />
          <div className="mt-8 grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <h1 className="font-heading font-extrabold tracking-tight text-4xl sm:text-5xl text-slate-900 leading-[1.05]">Where We Serve</h1>
              <p className="mt-4 text-lg text-slate-600 leading-relaxed">
                Roll-off rentals and front-load service across eight Yavapai County communities. Choose your area for local details, sizes, and FAQs.
              </p>
            </div>
            <ServiceAreaMap compact />
          </div>
        </div>
      </section>

      <section className="py-16 bg-slate-50" data-testid="areas-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICE_AREAS.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.05}>
              <Link
                to={`/service-areas/${a.slug}`}
                className="group block bg-white rounded-xl border border-slate-200 p-6 h-full hover:shadow-lg hover:-translate-y-1 hover:border-sky-300 transition-all"
                data-testid={`area-card-${a.slug}`}
              >
                <h2 className="font-heading font-bold text-xl text-slate-900 group-hover:text-sky-700 transition-colors">{a.name}</h2>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{a.tagline}</p>
                <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-heading font-semibold text-sky-700 group-hover:gap-2.5 transition-all">
                  Local service <ArrowRight className="h-4 w-4" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection title="In Our Service Area? Let's Go." />
    </>
  );
}
